import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useCompany } from "../../components/context/CompanyContext";
import Loading from "../../components/loading/loading";
import "../../global.css";
import { userRequest } from "../../requestMethods";
import CustomGrid from "../../components/grid/CustomGrid";
import Avatar from "@mui/material/Avatar";
import { generateFileUrl } from "../../requestMethods";
export default function VirtualOnTryList() {
  const currentUser = useSelector((state) => state.user.currentUser);
  const { companyId } = useCompany();
  const [data, setData] = useState([]);
  const [creditSummary, setCreditSummary] = useState(null);
  const [showcaseCreditSummary, setShowcaseCreditSummary] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const nav = useNavigate();
  useEffect(() => {
    if (companyId > 0) {
      loadData();
    }
  }, [companyId]);

  const loadData = async () => {
    setIsLoading(true);
    await Promise.all([
      getCredits(),
      getCreditSummary(),
      getShowcaseCreditSummary(),
    ]);
    setIsLoading(false);
  };

  const getCreditSummary = async () => {
    try {
      const res = await userRequest.get(`${companyId}/virtual/credits`);
      setCreditSummary(res.data);
    } catch (error) {
      console.error("Erro ao buscar resumo de créditos:", error);
    }
  };

  const getShowcaseCreditSummary = async () => {
    try {
      const res = await userRequest.get(
        `${companyId}/virtual/showcase/credits`,
      );
      setShowcaseCreditSummary(res.data);
    } catch (error) {
      console.error("Erro ao buscar resumo de créditos Smart Look IA:", error);
    }
  };

  const getCredits = async () => {
    try {
      let url = "";

      if (currentUser.isAdmin) {
        url = `${companyId}/virtual/credits/history?limit=1000`;
      }

      const res = await userRequest.get(url);

      setData(res.data.data || []);
    } catch (error) {
      console.error(error.code);
      if (error.code === 403) {
        nav(`../login`);
      }
    }
  };

  const formatDate = (date) => {
    if (!date) return "-";
    const d = new Date(date);
    // Ajusta para UTC para evitar diferença de fuso horário
    return new Date(
      d.getTime() + d.getTimezoneOffset() * 60000,
    ).toLocaleDateString("pt-BR");
  };

  const columns = [
    {
      field: "avatar",
      headerName: "Foto",
      align: "center",
      headerAlign: "center",
      width: 60,
      filterable: false,
      clickable: true,
      renderCell: (params) => {
        return (
          <>
            <Avatar
              sx={{ width: "30px", height: "30px" }}
              src={generateFileUrl(params.value)}
            />
          </>
        );
      },
    },
    {
      field: "productRef",
      headerName: "Referência",
      width: 80,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "title",
      headerName: "Produto",
      width: 120,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "name",
      headerName: "Cliente",
      width: 130,
      align: "left",
      headerAlign: "left",
      clickable: true,
    },
    {
      field: "contact",
      headerName: "Contato",
      width: 120,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "userName",
      headerName: "Venderdor(a) ",
      width: 130,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "createdAt",
      headerName: "Criada em",
      width: 100,
      align: "left",
      format: "dd/MM/yyyy",
    },
  ];
  return (
    <div className="cust-page">
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <div className="cust-title">Provador Virtual</div>
          <div
            style={{
              display: "flex",
              gap: "16px",
              marginBottom: "20px",
              flexWrap: "wrap",
            }}
          >
            {/* Créditos Virtual Try-On */}
            {creditSummary && (
              <div style={{ flex: 1, minWidth: 280 }}>
                <div
                  style={{
                    fontSize: "12px",
                    fontWeight: 600,
                    color: "#888",
                    marginBottom: 6,
                    textTransform: "uppercase",
                    letterSpacing: 1,
                  }}
                >
                  Provador Virtual
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "12px",
                    padding: "15px",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "8px",
                  }}
                >
                  <div style={{ textAlign: "center", flex: 1 }}>
                    <div style={{ fontSize: "13px", color: "#666" }}>Total</div>
                    <div style={{ fontSize: "22px", fontWeight: "bold" }}>
                      {creditSummary.totalCredits || 0}
                    </div>
                  </div>
                  <div style={{ textAlign: "center", flex: 1 }}>
                    <div style={{ fontSize: "13px", color: "#666" }}>
                      Usados
                    </div>
                    <div style={{ fontSize: "22px", fontWeight: "bold" }}>
                      {creditSummary.usedCredits || 0}
                    </div>
                  </div>
                  <div style={{ textAlign: "center", flex: 1 }}>
                    <div style={{ fontSize: "13px", color: "#666" }}>
                      Restantes
                    </div>
                    <div
                      style={{
                        fontSize: "22px",
                        fontWeight: "bold",
                        color:
                          creditSummary.remainingCredits > 0
                            ? "#4caf50"
                            : "#f44336",
                      }}
                    >
                      {creditSummary.remainingCredits || 0}
                    </div>
                  </div>
                  {creditSummary.isMonthlyPlan &&
                    creditSummary.nextRenewalAt && (
                      <div style={{ textAlign: "center", flex: 1 }}>
                        <div style={{ fontSize: "13px", color: "#666" }}>
                          Renovação
                        </div>
                        <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                          {formatDate(creditSummary.nextRenewalAt)}
                        </div>
                      </div>
                    )}
                </div>
              </div>
            )}

            {/* Créditos Vitrine AI */}
            <div style={{ flex: 1, minWidth: 280 }}>
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: 600,
                  color: "#888",
                  marginBottom: 6,
                  textTransform: "uppercase",
                  letterSpacing: 1,
                }}
              >
                Smart Look IA
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "12px",
                  padding: "15px",
                  backgroundColor: "#f5f5f5",
                  borderRadius: "8px",
                }}
              >
                <div style={{ textAlign: "center", flex: 1 }}>
                  <div style={{ fontSize: "13px", color: "#666" }}>Total</div>
                  <div style={{ fontSize: "22px", fontWeight: "bold" }}>
                    {showcaseCreditSummary?.totalCredits ?? 0}
                  </div>
                </div>
                <div style={{ textAlign: "center", flex: 1 }}>
                  <div style={{ fontSize: "13px", color: "#666" }}>Usados</div>
                  <div style={{ fontSize: "22px", fontWeight: "bold" }}>
                    {showcaseCreditSummary?.usedCredits ?? 0}
                  </div>
                </div>
                <div style={{ textAlign: "center", flex: 1 }}>
                  <div style={{ fontSize: "13px", color: "#666" }}>
                    Restantes
                  </div>
                  <div
                    style={{
                      fontSize: "22px",
                      fontWeight: "bold",
                      color:
                        (showcaseCreditSummary?.remainingCredits ?? 0) > 0
                          ? "#4caf50"
                          : "#f44336",
                    }}
                  >
                    {showcaseCreditSummary?.remainingCredits ?? 0}
                  </div>
                </div>
                <div style={{ textAlign: "center", flex: 1 }}>
                  <div style={{ fontSize: "13px", color: "#666" }}>
                    Próxima Renovação
                  </div>
                  <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                    {showcaseCreditSummary?.isMonthlyPlan &&
                    showcaseCreditSummary?.nextRenewalAt
                      ? formatDate(showcaseCreditSummary.nextRenewalAt)
                      : "—"}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="cust-card">
            <div className="cust-section-header">Histórico de Uso</div>
            <div style={{ padding: "16px" }}>
              <CustomGrid
                gridId="virtualList"
                rows={data}
                columns={columns}
                pageSize={45}
                checkboxSelection={false}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
}
